import { useSessao } from "./sessao";

/**
 * Visao do cliente (spec 060): as partes da area que o administrador desligou, pra todos os clientes. A chave de cada
 * aba e o endereco dela sem a barra (`/academy` e `academy`); o bloco do regulamento na tela do plano e `regulamentos`.
 * A area le junto com os dados da conta (`GET /v1/me`), entao a troca vale na proxima vez que a pessoa abrir ou recarregar.
 */
export const chaveDaRota = (rota: string) => rota.replace(/^\//, "");

/** `mostra("academy")`: se a parte aparece pra esta pessoa agora. */
export function useVisao() {
  const { estado } = useSessao();
  const ocultas = new Set(estado.status === "logado" ? (estado.usuario.capacidades.ocultas ?? []) : []);
  return { mostra: (chave: string) => !ocultas.has(chave) };
}
